export const MIXED_TIMEKEEPER_SELECTION_MESSAGE =
	"Select entries for one timekeeper at a time";

export function selectionTimekeeperId<
	T extends { timekeeperId?: string | null },
>(entries: T[]): string | null | false {
	const ids = new Set(entries.map((entry) => entry.timekeeperId ?? ""));
	if (ids.size > 1) return false;
	const [id] = ids;
	return id || null;
}
